export const resolveImagePath = (path, isWP) => {
  const image = new Image();
  image.src = window.location.origin + '/' + path;

  // const fallbackPath = path.replace('images/', './wp-content/plugins/test-react-plugin/build/images/');
  let fallbackPath = 'https://dmazpby8qypw2.cloudfront.net/ecomm/' + path; // production cdn
  if (window.location.origin === 'http://localhost' || window.location.origin === 'https://oregontopshelf.posabittest.com') {
    fallbackPath = 'https://d1gaaui79z0boh.cloudfront.net/ecomm/' + path; // qa cdn
  }

  if(!isWP){
    console.log("Path: ", image.src);
  } else {
    console.log("Fallback Path: ", fallbackPath);
  }
  return !isWP ? image.src : fallbackPath;
};
